import { Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import IphoneIcon from '@treyd-io/treyd-ui/icons/IphoneIcon';
import { useTranslation } from 'react-i18next';
import QRCode from 'react-qr-code';

export interface SwedenBankIdQrCodeProps {
  value: string;
}

export const SwedenBankIdQrCode = ({ value }: SwedenBankIdQrCodeProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <Stack alignItems={'center'} gap={3}>
      <QRCode
        value={value}
        style={{
          width: 240,
          height: 240,
          backgroundColor: theme.palette.background.paper,
          padding: theme.spacing(2),
          borderRadius: theme.spacing(1),
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: theme.palette.grey[200],
        }}
      />
      <Stack
        direction="row"
        alignItems={'center'}
        gap={0.5}
        textAlign="center"
        justifyContent="center"
        flexWrap="wrap">
        <IphoneIcon />
        <Typography variant="body1" color="textPrimary">
          {t('scan_the_code_with_your_mobile_bank_id_app')}
        </Typography>
      </Stack>
    </Stack>
  );
};
